import React from 'react'
import styled from "styled-components";
import useWindowSize from "./../hooks/useWindowSize";

function SidebarContentWrapper(props) {
  const screenStatus = useWindowSize();

  //for Gradient overlay
  let diveStyle = ` 
  overflow: scroll; 
  &::after {
    content: '';
    width: 100%;
    height:35px;
    bottom:0;
    left: 0;
    position: absolute;
    box-shadow: inset -2px -20px 15px -7px #fff;
  }`;
  const Layout = styled.div`
    ${(props.isSidebarOpen && screenStatus === "mobile") || (props.isSidebarOpen && screenStatus === "tablet") ? diveStyle : null}
  `;
    return (
        <Layout>
            {props.children}
        </Layout>
    )
}

export default SidebarContentWrapper
